// SPDX-License-Identifier: AGPL-3.0-or-later
import type {UserSettings} from '@app/features/user/state/UserSettings';
import UserSettingsState from '@app/features/user/state/UserSettings';

type UserSettingsPatch = Partial<UserSettings>;

async function persistUserSettings(settings: UserSettingsPatch): Promise<void> {
	await UserSettingsState.saveSettings(settings);
}

export async function update(settings: UserSettingsPatch): Promise<void> {
	await persistUserSettings(settings);
}
